<template>
  <!-- <component :is="currentComponent" :service="currentSvc"></component> -->
  <router-view></router-view>
</template>
<script>
import { URL_MAP } from './util';
import GCP from './gcp';
export default {
  components: {
    GCP,
  },
  data() {
    return {
      currentComponent: '',
      currentSvc: '',
    };
  },
  methods: {},
  mounted() {},
  created() {
    const {
      vendor = URL_MAP.DEFAULT.VENDOR,
      service = URL_MAP.DEFAULT.SERVICE,
    } = this.$route.query;
    //TODO : handle edge cases
    this.currentComponent = vendor.toUpperCase();
    this.currentSvc = service.toUpperCase();
  },
};
</script>
<style scoped></style>
